// extracted by mini-css-extract-plugin
module.exports = {"base":"TrialDetailsProfiles_base__3kZll"};